import { createAction, createAsyncAction } from "typesafe-actions";
import creativeMappingsConstants from "store/features/creativeMappings/overivew/overview.constants";
import { CreativeMappingsRuleForm } from "validation/components/CreativeMappings/creativeMappingsRules";

const {
    FETCH_CREATIVE_MAPPINGS_REQUEST,
    FETCH_CREATIVE_MAPPINGS_SUCCESS,
    FETCH_CREATIVE_MAPPINGS_FAILED,
    CREATE_CREATIVE_MAPPING_REQUEST,
    CREATE_CREATIVE_MAPPING_SUCCESS,
    CREATE_CREATIVE_MAPPING_FAILED,
    UPDATE_CREATIVE_MAPPING_REQUEST,
    UPDATE_CREATIVE_MAPPING_SUCCESS,
    UPDATE_CREATIVE_MAPPING_FAILED,
    DELETE_CREATIVE_MAPPING_REQUEST,
    DELETE_CREATIVE_MAPPING_SUCCESS,
    DELETE_CREATIVE_MAPPING_FAILED,
    TOGGLE_ROW_EDIT,
    UNSET_CREATIVE_MAPPINGS_ROW_EDIT,
} = creativeMappingsConstants;

export const fetchCreativeMappings = createAsyncAction(
    FETCH_CREATIVE_MAPPINGS_REQUEST,
    FETCH_CREATIVE_MAPPINGS_SUCCESS,
    FETCH_CREATIVE_MAPPINGS_FAILED
)<void, CreativeMappingsRuleForm[], ErrorHandler>();

export const createCreativeMapping = createAsyncAction(
    CREATE_CREATIVE_MAPPING_REQUEST,
    CREATE_CREATIVE_MAPPING_SUCCESS,
    CREATE_CREATIVE_MAPPING_FAILED
)<CreativeMappingsRuleForm, void, ErrorHandler>();

export const updateCreativeMapping = createAsyncAction(
    UPDATE_CREATIVE_MAPPING_REQUEST,
    UPDATE_CREATIVE_MAPPING_SUCCESS,
    UPDATE_CREATIVE_MAPPING_FAILED
)<CreativeMappingsRuleForm, void, ErrorHandler>();

export const deleteCreativeMapping = createAsyncAction(
    DELETE_CREATIVE_MAPPING_REQUEST,
    DELETE_CREATIVE_MAPPING_SUCCESS,
    DELETE_CREATIVE_MAPPING_FAILED
)<number, void, ErrorHandler>();

export const toggleRowEdit = createAction(TOGGLE_ROW_EDIT)<{ id: number }>();

export const unsetCreativeMappingsRowEdit = createAction(UNSET_CREATIVE_MAPPINGS_ROW_EDIT)();
